import { useLocation } from '@/lib/router-compat';
import { useCountry } from './useCountry';

const BASE_URL = 'https://roautomarket.ro';

/**
 * Hook that generates the correct canonical URL for the current page
 * based on country and path
 * Ensures URLs are clean (no trailing slashes, no query parameters)
 */
export const useCanonicalUrl = (): string => {
  const location = useLocation();
  const { country } = useCountry();
  
  // Get the current path without search params or hash
  let path = location.pathname;
  
  // Remove country prefix if present to get the base path
  const basePath = path.replace(/^\/(uk|de)/i, '') || '/';
  
  // Build canonical URL with country prefix
  const countryPrefix = country === 'RO' ? '' : `/${country.toLowerCase()}`;
  const canonicalPath = `${countryPrefix}${basePath}`;
  
  // Remove trailing slash (except for root)
  const cleanPath = canonicalPath === '/' ? '/' : canonicalPath.replace(/\/$/, '');
  
  return `${BASE_URL}${cleanPath}`;
};
